import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap";

@Component({
  selector: 'app-client-reviews',
  templateUrl: './client-reviews.component.html',
  styleUrls: ['./client-reviews.component.scss']
})
export class ClientReviewsComponent implements OnInit {
  reviwes: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  view: any;
  totalRec: any;
  currentPage: any;
  page: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) { }

  ngOnInit() {
    this.getAllClientReviews(1);
  }



  getAllClientReviews(pageIndex){
    let size = 10;
    let page = pageIndex - 1;
    this.userService.getAllActiveReviews(size,page).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.reviwes =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }


  viewMore(view: any) {
    this.view=view;
    this.addModal.show();
  }

  approve(id){
    this.userService.approve(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.getAllClientReviews(this.currentPage);
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  reject(id){
    this.userService.regect(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.getAllClientReviews(this.currentPage);
          this.notifier.notify('success', res.responseDesc);
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
